import React from "react";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import PageTitle from "../../components/PageTitle";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./Attendance.css";

const Attendance = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["attendanceData"],
    queryFn: async () => {
      const response = await axiosget("ms_course_contact");
      return response?.data;
    },
  });

  const calculatePercentage = (attended, expected) => {
    return expected > 0 ? Math.round((attended / expected) * 100) : 0;
  };

  const getProgressColor = (percentage) => {
    if (percentage >= 80) return "#4CAF50"; // Green
    if (percentage >= 75) return "#FFC107"; // Amber
    return "#F44336"; // Red
  };

  return (
    <div className="attendance-container">
      <PageTitle title="My Attendance Dashboard" sub="Track your course attendance for the current semester" />

      {isLoading && <Loader />}
      {error && <ErrorResponse type="danger" message={`Error: ${error.message}`} />}
      {data?.type !== undefined && <ErrorResponse type="danger" message={data?.message} />}

      {data && data?.type === undefined && (
        <div className="attendance-content">
          <div className="attendance-summary-cards">
            {data
              ?.sort((a, b) => b.expected - a.expected)
              ?.slice(0, 3)
              .map((course) => {
                const percentage = calculatePercentage(course.attended, course.expected);
                return (
                  <div className="summary-card" key={course.courseinfo?.code}>
                    <div className="course-info">
                      <h3>{course.courseinfo?.code}</h3>
                      <p>{course.courseinfo?.name}</p>
                    </div>
                    <div className="progress-container">
                      <CircularProgressbar
                        value={percentage}
                        text={`${percentage}%`}
                        styles={{
                          path: {
                            stroke: getProgressColor(percentage),
                          },
                          text: {
                            fill: "#333",
                            fontSize: "16px",
                            fontWeight: "bold",
                          },
                        }}
                      />
                    </div>
                    <div className="attendance-details">
                      <span>
                        {course.attended}/{course.expected} classes
                      </span>
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="attendance-table-container">
            <table className="attendance-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Course</th>
                  <th>Details</th>
                  <th>Attendance</th>
                  <th>Progress</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((course, index) => {
                  const percentage = calculatePercentage(course.attended, course.expected);
                  return (
                    <tr key={`${course.courseinfo?.code}-${index}`}>
                      <td>{index + 1}</td>
                      <td>
                        <div className="course-title">
                          <strong>{course.courseinfo?.code}</strong>
                          <span>{course.courseinfo?.name}</span>
                        </div>
                      </td>
                      <td>
                        <div className="course-meta">
                          <span>Level {course.level}</span>
                          <span>Sem {course.semester}</span>
                          <span>{course.credit} Credits</span>
                        </div>
                      </td>
                      <td>
                        <div className="attendance-count">
                          {course.attended}/{course.expected}
                        </div>
                      </td>
                      <td>
                        <div className="progress-bar-container">
                          <div
                            className="progress-bar"
                            style={{
                              width: `${percentage}%`,
                              backgroundColor: getProgressColor(percentage),
                            }}
                          ></div>
                          <span className="percentage-text">{percentage}%</span>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default Attendance;
